var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pxfLegalMentionsText
    ? _c("div", { staticClass: "mt-2" }, [
        _c("span", {
          staticClass: "fw-bold small",
          domProps: { innerHTML: _vm._s(_vm.pxfLegalMentionsText) },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }